import React from "react";
import PropTypes from "prop-types";
import { LuCalendarPlus, LuCalendarHeart, LuCalendarX2 } from "react-icons/lu";
import IconButton from '../../ui/Button/IconButton.jsx';
import Favorite from "../Favorite.jsx";

/**
 * ProductFavoriteButton Molecule - Renders appropriate favorite button based on variant
 * @component
 * @example
 * // Search variant
 * <ProductFavoriteButton
 *   variant="search"
 *   giftId="123"
 *   giftImage="https://..."
 * />
 * 
 * // Event variant
 * <ProductFavoriteButton
 *   variant="event"
 *   heart="delete"
 *   onHeartClick={() => {}}
 * />
 */
const ProductFavoriteButton = ({
    variant = "search",
    giftId,
    giftImage,
    heart,
    onHeartClick,
    isOpen,
    setOpenComponentID,
    className = "",
}) => {
    if (variant === "search") {
        return (
            <div className={`absolute right-4 top-4 ${className}`}>
                <Favorite
                    gift_id={giftId}
                    gift_image={giftImage}
                    isOpen={isOpen}
                    setOpenComponentID={setOpenComponentID}
                />
            </div>
        );
    }

    // Event variant
    return (
        <div className={`absolute top-4 right-4 ${className}`}>
            <IconButton
                icon={
                    heart === "delete" ? (
                        <>
                            <LuCalendarHeart className="w-5 h-5 text-red-500 group-hover/button:hidden" />
                            <LuCalendarX2 className="w-5 h-5 text-red-500 hidden group-hover/button:block group-hover/button:text-white" />
                        </>
                    ) : (
                        <LuCalendarPlus className="w-5 h-5" />
                    )
                }
                variant="favorite"
                size="iconMd"
                rounded="full"
                onClick={onHeartClick}
            />
        </div>
    );
};

ProductFavoriteButton.propTypes = {
    variant: PropTypes.oneOf(["search", "event"]),
    giftId: PropTypes.string,
    giftImage: PropTypes.string,
    heart: PropTypes.string,
    onHeartClick: PropTypes.func,
    isOpen: PropTypes.bool,
    setOpenComponentID: PropTypes.func,
    className: PropTypes.string,
};

export default ProductFavoriteButton;
